import { alpha } from "@mui/material/styles";

function primaryTintBg(theme, strong = false) {
  const main = theme.palette.primary.main;
  return alpha(main, theme.palette.mode === "dark" ? (strong ? 0.18 : 0.12) : strong ? 0.12 : 0.08);
}

function secondaryTintBg(theme, strong = false) {
  const main = theme.palette.secondary.main;
  return alpha(main, theme.palette.mode === "dark" ? (strong ? 0.16 : 0.1) : strong ? 0.12 : 0.08);
}

function tableHeadBackground(theme) {
  return theme.palette.mode === "dark"
    ? theme.palette.grey[900]
    : theme.palette.background.alt ?? "#F8FAFC";
}

function quickFilterTrackBg(theme) {
  return theme.palette.mode === "dark"
    ? "rgba(255, 255, 255, 0.05)"
    : theme.palette.background.alt ?? "#F1F5F9";
}

function searchPillBg(theme) {
  return theme.palette.mode === "dark"
    ? "rgba(255, 255, 255, 0.05)"
    : "rgba(15, 23, 42, 0.04)";
}

export {
  primaryTintBg,
  quickFilterTrackBg,
  searchPillBg,
  secondaryTintBg,
  tableHeadBackground,
};
